import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-navigation-bar-desktop-spacer',
  templateUrl: './navigation-bar-desktop-spacer.component.html',
  styleUrls: ['./navigation-bar-desktop-spacer.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationBarDesktopSpacerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/navigation-bar-desktop-spacer/navigation-bar-desktop-spacer.component.ts